(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["japan-items-brands-az"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('[data-ji-brands]').forEach(function(root){
      var input=root.querySelector('.ji-brands__search');
      var items=Array.prototype.slice.call(root.querySelectorAll('.ji-brands__list .ji-brands__item'));
      var groups=Array.prototype.slice.call(root.querySelectorAll('.ji-brands__group'));
      var navLinks=Array.prototype.slice.call(root.querySelectorAll('.ji-brands__nav-link'));
      var empty=root.querySelector('.ji-brands__empty');

      navLinks.forEach(function(a){
        if(!document.getElementById(a.dataset.target)) a.classList.add('is-disabled');
      });

      if(!input) return;
      input.addEventListener('input',function(){
        var q=input.value.trim().toLowerCase();
        root.classList.toggle('is-searching',q.length>0);
        var visible=0;
        items.forEach(function(it){
          var match=!q||(it.dataset.name||'').indexOf(q)!==-1;
          it.hidden=!match;
          if(match) visible++;
        });
        groups.forEach(function(g){
          g.hidden=q?!g.querySelector('.ji-brands__item:not([hidden])'):false;
        });
        if(empty) empty.hidden=!(q&&visible===0);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["japan-items-collection-list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var el = document.querySelector('#collections-carousel');
  if (!el) return;

  var perDesktop = parseInt(el.dataset.perPageDesktop, 10) || 4;
  var perTablet  = parseInt(el.dataset.perPageTablet, 10) || 2;
  var perMobile  = parseInt(el.dataset.perPageMobile, 10) || 1;

  // dataset zwraca stringi
  var arrows = (el.dataset.arrows === 'true');

  var splide = new Splide(el, {
    type: 'slide',
    perPage: perDesktop,
    breakpoints: {
      768: { perPage: perTablet },
      480: { perPage: perMobile }
    },
    classes: {
		arrows: 'splide__arrows',
		arrow : 'splide__arrow',
		prev  : 'splide__arrow--prev rtl-flip-x btn btn-primary--animate btn-icon btn-small',
		next  : 'splide__arrow--next rtl-flip-x btn btn-primary--animate btn-icon btn-small',
    },
    gap: '1rem',
    arrows: arrows,
    pagination: false,
    autoplay: false,
    speed: 600,
    easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)'
  });

  splide.mount();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["japan-items-related-products"]) return;
  try {
    
  if (!customElements.get('ji-seo-recommendations')) {
    customElements.define('ji-seo-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.loaded) return;
        this.loaded = true;
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.controller = new AbortController();
          const url = new URL(this.dataset.url, window.location.origin);
          const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          fetch(url, {signal: this.controller.signal}).then(response => {
            if (!response.ok) throw new Error('Recommendations unavailable');
            return response.text();
          }).then(html => {
            if (!this.isConnected) return;
            const document = new DOMParser().parseFromString(html, 'text/html');
            const result = document.querySelector('[data-ji-recommendation-results]');
            if (result) this.querySelector('[data-ji-recommendation-results]').replaceChildren(...result.childNodes);
          }).catch(() => {});
        }, {rootMargin: '200px'});
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.loaded = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
